import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AddCityComponent } from './add-city/add-city.component';
import { AddCountryComponent } from './add-country/add-country.component';
import { CityListComponent } from './city-list/city-list.component';
import { CountryListComponent } from './country-list/country-list.component';
import { UpdateCityComponent } from './update-city/update-city.component';
import { UpdateCountryComponent } from './update-country/update-country.component';
 const routes: Routes = [
  
  { path: 'add-city/:id',      component: AddCityComponent },
  { path: 'add-country',      component: AddCountryComponent },

  { path: 'city-list/:id',      component: CityListComponent },
  { path: 'country-list',      component: CountryListComponent },
  { path: 'update-city/:id/:cid',      component: UpdateCityComponent },
  { path: 'update-country/:id',      component: UpdateCountryComponent }

];
 
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class CountryCityRoutingModule { }
  